import jsPDF from "jspdf";
import "jspdf-autotable";

export const exportToPDFUser = (filteredData) => {
    const doc = new jsPDF();
    
    doc.setFontSize(16);
    doc.text('Users Report', 14, 15);
    
    const tableData = filteredData.map(user => [
      user.name,
      user.email,
      user.role,
      user.created_at ? new Date(user.created_at).toLocaleDateString() : 'N/A'
    ]);
    
    doc.autoTable({
      head: [['Name', 'Email', 'Role', 'Created Date']],
      body: tableData,
      startY: 25,
      theme: 'grid',
      styles: { 
        fontSize: 10,
        cellPadding: 3
      },
      headStyles: {
        fillColor: [66, 139, 202],
        textColor: [255, 255, 255]
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245]
      }
    });
    
    doc.save('users_report.pdf');
  };
  